import type { DATEPICKER_MODE } from './constant';
import VDatePickerContext from './context';
import type { VDatePickerContextValue } from './type';

const useVDatePickerContext = <
  M extends DATEPICKER_MODE | Lowercase<DATEPICKER_MODE>,
>() => VDatePickerContext.hook<VDatePickerContextValue<M>>();

export default useVDatePickerContext;
